import {getProductExtraList} from "@/api/ProductExtra"

export default {
  addProductExtra({ commit }, productExtra) {
    return new Promise((resolve, reject) => {
      commit('ADD_PRODUCT_EXTRA', productExtra)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsProductExtra({ commit },payload) {
    return new Promise((resolve, reject) => {
      getProductExtraList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_PRODUCT_EXTRA', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateProductExtra({ commit }, productExtra) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_PRODUCT_EXTRA', productExtra)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeProductExtra({ commit }, productExtraId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_PRODUCT_EXTRA', productExtraId)
          resolve();
    })
  }
};